module.exports = __webpack_public_path__ + "img/mockbanner.85391970.png";